import { ICellRendererParams } from '@ag-grid-community/core'
import Typography from 'antd/lib/typography'
import React from 'react'

function ToolTipTextRenderer(params: ICellRendererParams): React.ReactElement {
  return (
    <Typography.Text ellipsis={{ tooltip: params.value }} style={{ width: '100%' }}>
      {params.value}
    </Typography.Text>
  )
}
export default ToolTipTextRenderer
